import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconRatingsComponent } from "./med-icon-ratings.component";

@NgModule({
  declarations: [
    MedIconRatingsComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconRatingsComponent,
  ],
})
export class MedIconRatingsModule { }
